import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';

import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
// import { copyTextToClipboard } from '../shared/Utilities';
import FormControl from '@mui/material/FormControl';

// https://github.com/react-monaco-editor/react-monaco-editor
// import MonacoEditor from 'react-monaco-editor';

import Session from '../shared/Session';


export default function Code() {
    // const { id } = useParams();
    // const [fileData, setFileData] = useState('');
    // const [language, setLanguage] = useState("javascript");

    const [shell, setShell] = useState('');
    const [shellCommand, setShellCommand] = useState('');

    // const [loadingData, setLoadingData] = useState(false);
    // const [files, setFiles] = useState({});

    // if (!loadingData) {
    //     setLoadingData(true);
    //     Session.api("GET", `/deployments/${id}/files`, {}, setFiles);
    // }

    // function editorDidMount(editor: any, monaco: any) {
    //     console.log(editor);
    //     console.log(monaco);
    //     // editor.focus();
    //     (document.getElementById("shellCommandField") as HTMLInputElement).focus();
    // }

    // {
    //     type: "directory" || "file",
    //     name: "string",
    //     path: "string",
    //     files: [
    //         {
    //             type: "directory" || "file",
    //             name: "string",
    //             path: "string",
    //             files: [] | undefined
    //         }
    //     ]
    // }

    // function buildTree(file: any) {
    //     console.log(file);
    //     if (file.type === "directory") {
    //         return <TreeItem nodeId={file.path} label={file.name}>
    //             {file.files.map((f: any) => {
    //                 return buildTree(f);
    //             })}
    //         </TreeItem>;
    //     }
    //     return <TreeItem nodeId={file.path} label={file.name} onClick={() => selectFile(file.path)} />;
    // }

    // function selectFile(file: any) {
    //     if (file.type === "file") {
    //         if (file.name.endsWith(".js")) {
    //             setLanguage("javascript");
    //         } else if (file.name.endsWith(".py")) {
    //             setLanguage("python");
    //         } else if (file.name.endsWith(".sh")) {
    //             setLanguage("shell");
    //         } else if (file.name.endsWith(".json")) {
    //             setLanguage("json");
    //         } else if (file.name.endsWith(".yaml")) {
    //             setLanguage("yaml");
    //         } else if (file.name.endsWith(".yml")) {
    //             setLanguage("yaml");
    //         } else if (file.name.endsWith(".txt")) {
    //             setLanguage("text");
    //         } else if (file.name.endsWith(".md")) {
    //             setLanguage("markdown");
    //         } else if (file.name.endsWith(".html")) {
    //             setLanguage("html");
    //         } else if (file.name.endsWith(".css")) {
    //             setLanguage("css");
    //         } else if (file.name.endsWith(".xml")) {
    //             setLanguage("xml");
    //         } else if (file.name.endsWith(".sql")) {
    //             setLanguage("sql");
    //         } else if (file.name.endsWith(".txt")) {
    //             setLanguage("text");
    //         } else {
    //             setLanguage("text");
    //         }

    //         Session.api("GET", `/deployments/${id}/files/${file.path}`, {}, setFileData);
    //     }
    //     return <TreeItem nodeId={file.path} label={file.name} />;
    // }


    // var filesTree = buildTree(files);

    return <div style={{
        height: "90%",
        width: "100%",
        display: "flex",
        padding: "0px",
        margin: "-24px -24px -24px -24px"
    }}>
        <div style={{ height: "100%", width: "15%" }}>
            <Box sx={{ minHeight: 180, flexGrow: 1, maxWidth: 300 }} style={{ marginTop: "8%" }}>
                <TreeView
                    aria-label="file system navigator"
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                >
                    <TreeItem nodeId="1" label="Applications">
                        <TreeItem nodeId="2" label="Calendar" />
                    </TreeItem>
                    <TreeItem nodeId="5" label="Documents">
                        <TreeItem nodeId="10" label="OSS" />
                        <TreeItem nodeId="6" label="MUI">
                            <TreeItem nodeId="8" label="index.js" />
                        </TreeItem>
                    </TreeItem>
                    {/* {filesTree} */}
                </TreeView>
            </Box>
        </div>
        <div style={{ height: "100%", width: "85%" }}>
            <div style={{ height: "75%", width: "100%" }}>
                {/* https://microsoft.github.io/monaco-editor/typedoc/interfaces/editor.IStandaloneEditorConstructionOptions.html */}
                {/* <MonacoEditor
                    width="100%"
                    height="100%"
                    // width="800"
                    // height="600"
                    language={language}
                    theme="vs-dark"
                    value={fileData}
                    options={{
                        autoIndent: 'full',
                        contextmenu: true,
                        fontFamily: 'monospace',
                        fontSize: 13,
                        lineHeight: 24,
                        hideCursorInOverviewRuler: true,
                        matchBrackets: 'always',
                        minimap: {
                            enabled: true,
                        },
                        scrollbar: {
                            horizontalSliderSize: 4,
                            verticalSliderSize: 18,
                        },
                        selectOnLineNumbers: true,
                        roundedSelection: false,
                        readOnly: false,
                        cursorStyle: 'line',
                        automaticLayout: true,
                    }}
                    onChange={(e: any) => {
                        setFileData(e.target.value);
                    }}
                    editorDidMount={editorDidMount}
                /> */}
            </div>
            <div style={{ height: "25%", width: "100%" }}>
                <Paper style={{ height: "100%", width: "100%" }}>
                    {shell}
                </Paper>
                <FormControl>
                    <TextField
                        id="shellCommandField"
                        placeholder="#!/bin/bash $ "
                        type="text"
                        required={false}
                        value={shellCommand}
                        // helperText={label}
                        variant="standard"
                        size="medium"
                        onChange={(e) => {
                            setShellCommand(e.target.value);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                Session.api("POST", `/shell`, shellCommand, (result: any) => {
                                    var concatShell = shell + "\n" + result;
                                    if (concatShell.length > 32768) {
                                        concatShell = concatShell.slice(2048);
                                    }
                                    setShell(concatShell);
                                });
                            }
                        }}
                    />
                </FormControl>
            </div>
        </div>
    </div>
    // return <>
    //     <table style={{ height: "100%", width: "100%" }}>
    //         <tr style={{ height: "100%", width: "100%" }}>
    //             <td style={{ height: "100%", width: "20%", verticalAlign: "top" }}>
    //             </td>
    //             <td style={{ position: "absolute", height: "100%", width: "80%" }}>
    //                 <table style={{ height: "100%", width: "100%" }}>
    //                     <tr style={{ position: "absolute", height: "60%", width: "100%" }}>
    //                         <td style={{ height: "100%", width: "100%" }}>
    //                         </td>
    //                     </tr>
    //                     <tr style={{ height: "25%", width: "100%" }}>
    //                         <td style={{ height: "100%", width: "100%" }}>
    //                         </td>
    //                     </tr>
    //                 </table>
    //             </td>
    //         </tr>
    //     </table>
    // </>;
}
